import { useMerchantFeatures } from "@/hooks/use-merchant-features";

export const useIsInsights = () => {
  const features = useMerchantFeatures();
  return features.includes("insights");
};
